import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  actionEdit: {
    color: theme.palette.orange.main,
  },
  actionDel: {
    color: theme.palette.red.main,
    cursor: 'pointer',
  },
  buttonImport: {
    marginRight:6,
    background: theme.palette.orange.main,
    cursor: 'pointer'
  },
  button:{
    marginRight:6,
  },
  paper: {
    border: '1px solid #d3d4d5',
  },
}));
